export function toCamelKey(key) {
  return String(key || "").replace(/_([a-z0-9])/g, (_, char) =>
    char.toUpperCase(),
  );
}

export function normalizeKeys(
  record,
  { aliases = null } = {},
) {
  if (!record || typeof record !== "object") return record;
  const next = {};
  Object.keys(record).forEach((key) => {
    if (key.includes("_")) return;
    next[key] = record[key];
  });
  Object.keys(record).forEach((key) => {
    if (!key.includes("_")) return;
    const camelKey = toCamelKey(key);
    if (camelKey && next[camelKey] === undefined) {
      next[camelKey] = record[key];
    }
  });
  if (aliases && typeof aliases === "object") {
    Object.entries(aliases).forEach(([sourceKey, targetKey]) => {
      if (!sourceKey || !targetKey) return;
      if (record[sourceKey] !== undefined && next[targetKey] === undefined) {
        next[targetKey] = record[sourceKey];
      }
    });
  }
  return next;
}

export function normalizeList(items, options) {
  return Array.isArray(items) ? items.map((item) => normalizeKeys(item, options)) : [];
}
